import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { useMemo } from 'react';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import ExpandCollapseCell from './ExpandCollapseCell';

const PlannedAmountDetailHeaderCell = (props: GridHeaderCellProps) => {
  const { holdAmountData, setHoldAmountData } = useViewCheckbook();
  const isAllExpanded = useMemo(
    () => holdAmountData.some((transaction) => transaction.expanded),
    [holdAmountData]
  );
  const handleHeaderCellExpand = () => {
    setHoldAmountData((prev) => [...prev].map((item) => ({ ...item, expanded: !isAllExpanded })));
  };

  return (
    <th className="k-header paddingHeader k-hierarchy-cell" style={{ borderBottomWidth: '0px' }}>
      <ExpandCollapseCell
        expand={isAllExpanded}
        onExpand={handleHeaderCellExpand}
        title="Expand/Collapse All"
      />
    </th>
  );
};

export default PlannedAmountDetailHeaderCell;
